import { render, staticRenderFns } from "./page28.vue?vue&type=template&id=5c248cd1&scoped=true&"
import script from "./page28.vue?vue&type=script&lang=js&"
export * from "./page28.vue?vue&type=script&lang=js&"
import style0 from "./page28.vue?vue&type=style&index=0&id=5c248cd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c248cd1",
  null
  
)

export default component.exports